module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_10.b4589e1d.png";